import { render } from "./BadScoreTypeAddModal.vue?vue&type=template&id=333a89fa&scoped=true"
import script from "./BadScoreTypeAddModal.vue?vue&type=script&lang=js"
export * from "./BadScoreTypeAddModal.vue?vue&type=script&lang=js"

import "./BadScoreTypeAddModal.vue?vue&type=style&index=0&id=333a89fa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333a89fa"]])

export default __exports__